import React, { useState } from "react";
import Terminate from "./common/Terminate";
import FreezeCard from "./common/FreezeCard";

const renderTerminate = ({ setShowTerminate, ...rest }) => (
  <Terminate {...rest} />
);

const renderFreeze = ({ setShowTerminate, ...rest }) => (
  <>
    {/* {((rest || {}).user || {}).isAdmin ? <ActiveInactive {...rest} /> : <></>} */}
    <FreezeCard {...rest} />
    {((rest || {}).roles || {}).admin ? (
      <button className="mt-12" onClick={() => setShowTerminate(true)}>
        Lost or stolen card?
        <span className="underline ml-2">Click here</span>
      </button>
    ) : (
      <></>
    )}
  </>
);

const ManageCardMobile = ({
  user,
  isRiskLocked,
  SettingsButton,
  SettingsInputContainer,
  roles,
}) => {
  const [showTerminate, setShowTerminate] = useState(false);
  const Component = showTerminate ? renderTerminate : renderFreeze;

  if (isRiskLocked) {
    return null;
  }
  return (
    <div className="flex flex-col">
      <Component
        user={user}
        roles={roles}
        SettingsButton={SettingsButton}
        SettingsInputContainer={SettingsInputContainer}
        setShowTerminate={setShowTerminate}
      />
    </div>
  );
};

export default ManageCardMobile;
